import React from 'react';
import PropTypes from 'prop-types';

import { ButtonTypes, IconTypes } from 'constants/Constants';
import Button from 'components/common/Button/Button';

const PageLoadingComponent = ({ error, retry, pastDelay }) => {
	if (error) {
		return (
			<>
				<div>
					<h3>{'Error when loading page'}</h3>
					<Button onClickCallback={retry} text={'Retry'} color={ButtonTypes.PRIMARY} size={ButtonTypes.MEDIUM} icon={IconTypes.RESET} />
				</div>
			</>
		);
	}

	if (pastDelay) {
		return {};
	}

	return null;
};

PageLoadingComponent.propTypes = {
	error: PropTypes.bool,
	pastDelay: PropTypes.bool,
	// Functions
	retry: PropTypes.func
};

export default PageLoadingComponent;
